import React, { lazy } from 'react';
import { StarIcon as StarIconLucide } from 'lucide-react';
export const SocialProofSection = () => {
  return <section className="py-4 md:py-6 bg-bttf-bg relative overflow-hidden" data-id="element-479">
      <div className="container mx-auto px-4 relative z-10 max-w-2xl" data-id="element-480">
        <div className="border border-[#b8860b]/60 rounded-xl p-6 md:p-8 bg-[#1a1408] shadow-[0_0_40px_rgba(184,134,11,0.25)]" data-id="element-481">
          <h3 className="text-xl md:text-2xl font-bold font-future text-[#FFB800] text-center mb-5" data-id="element-482">
            12,847 Fans Already Own This Collection
          </h3>

          <div className="bg-[#0f0d08] border border-[#b8860b]/20 rounded-lg p-5 md:p-6" data-id="element-483">
            <div className="flex justify-center mb-5" data-id="element-484">
              <div className="w-56 h-56 md:w-64 md:h-64 rounded-lg overflow-hidden border border-[#b8860b]/30" data-id="element-485">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k5uGmvWP6Z3JLguVC5UCZM/3.png" alt="Newman Family, Boston" className="w-full h-full object-cover" width="200" height="200" loading="lazy" decoding="async" data-id="element-486" />
              </div>
            </div>

            <div className="flex justify-center gap-1 mb-4" data-id="element-487">
              {[...Array(5)].map((_, i) => <StarIconLucide key={i} className="h-5 w-5 text-[#FFB800] fill-[#FFB800]" data-id="element-488" />)}
            </div>

            <p className="text-base md:text-lg italic text-white font-body text-center leading-relaxed mb-4" data-id="element-489">
              "A masterpiece for collectors. If you grew up with Marty and Doc,
              this is your time machine."
            </p>

            <p className="text-[#FFB800] font-semibold font-body text-center text-sm" data-id="element-490">
              — Newman Family, Boston
            </p>
          </div>
        </div>
      </div>
    </section>;
};